"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSearch = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const material_1 = require("@mui/material");
const InputBase_1 = tslib_1.__importDefault(require("@mui/material/InputBase"));
const ArgusUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/ArgusUtils"));
const UrlUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/UrlUtils"));
const IconComponent_1 = tslib_1.__importDefault(require("../components/IconComponent"));
const MneListItem_1 = tslib_1.__importDefault(require("../components/MneListItem"));
const HoverMenu_1 = require("./HoverMenu");
const MenuSearchRoot = (0, material_1.styled)("div", {
    name: "MenuSearch",
    slot: "root",
    overridesResolver: (styles) => styles.root,
})(({ theme }) => ({
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(-1.5),
}));
const StyledIconComponent = (0, material_1.styled)(IconComponent_1.default)(({ theme }) => ({
    color: theme.palette.text.secondary,
    height: "1.2em",
    width: "1.2em",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginRight: theme.spacing(1.5),
}));
const InputBase = (0, material_1.styled)(InputBase_1.default)(({ theme }) => ({
    color: theme.palette.text.secondary,
    "& .MuiInputBase-input": {
        width: "100%",
    },
}));
const InputWrapper = (0, material_1.styled)("div")(({ theme, open }) => ({
    paddingLeft: theme.spacing(1),
    display: "flex",
    backgroundColor: open && theme.palette.action.hover,
    borderRadius: theme.spacing(0.5),
}));
const HoverOverlay = (0, material_1.styled)("div")(({ theme }) => ({
    width: "36px",
    height: "30px",
    position: "absolute",
    borderRadius: theme.spacing(0.5),
    ":hover": {
        backgroundColor: theme.palette.action.hover,
    },
}));
const handleSearch = (event) => {
    // Using `currentTarget` instead of `target`. Since TS lies and says `target.value` is not defined
    const inputValue = event.currentTarget.value;
    // We only care about if the user press enter.
    if (!(event.key === "Enter"))
        return;
    event.preventDefault();
    const AGGREGATED_EVENT_REGEX = /^(AGGR|NIDS)/;
    // If this is an aggregated event, redirect to event page.
    if (inputValue.match(AGGREGATED_EVENT_REGEX)) {
        window.location.href = ArgusUtils.toSpaUrl({
            pathname: `/event/redirect/view/${inputValue}`,
            search: "",
        });
    }
    else {
        // Everything not an aggregated event, redirect to case.
        window.location.href = ArgusUtils.toSpaUrl({
            pathname: `case/redirect/menuSearch/`,
            search: UrlUtils.encodeUrlCriteria({
                inputValue,
            }),
        });
    }
};
exports.handleSearch = handleSearch;
const MenuSearch = ({ open, label }) => {
    const inputRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(MenuSearchRoot, null,
        react_1.default.createElement(HoverMenu_1.HoverMenuBase, { openMenu: open, content: react_1.default.createElement(InputBase, { placeholder: "Search", inputProps: { ref: inputRef }, sx: {
                    p: 1,
                    "& .MuiInputBase-input": {
                        paddingLeft: 0,
                    },
                }, autoFocus: true, onKeyDown: exports.handleSearch }) },
            react_1.default.createElement(MneListItem_1.default, { onClick: () => inputRef.current.focus() },
                react_1.default.createElement(InputWrapper, { open: open },
                    react_1.default.createElement(StyledIconComponent, { iconId: "search" }),
                    react_1.default.createElement(InputBase, { placeholder: open ? label : "", inputProps: {
                            ref: inputRef,
                        }, onKeyDown: exports.handleSearch })),
                react_1.default.createElement(HoverOverlay, { className: "SearchHoverOverlay", hidden: open })))));
};
exports.default = MenuSearch;
